/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Not_FoundInputs */

const en_us2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This exercise is no longer in your plan.`)
};

const pt_br2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício não está mais no seu plano.`)
};

const es_419_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ejercicio ya no está en tu plan.`)
};

const pt_pt2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício já não está no teu plano.`)
};

const fr_fr2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet exercice n'est plus dans ton programme.`)
};

const de_de2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung ist nicht mehr in deinem Plan.`)
};

const it_it2_swap_not_found = /** @type {(inputs: Swap_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo esercizio non è più nella tua scheda.`)
};

/**
* | output |
* | --- |
* | "This exercise is no longer in your plan." |
*
* @param {Swap_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_not_found = /** @type {((inputs?: Swap_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_not_found(inputs)
	if (locale === "es-419") return es_419_swap_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_not_found(inputs)
	if (locale === "de-DE") return de_de2_swap_not_found(inputs)
	if (locale === "it-IT") return it_it2_swap_not_found(inputs)
	return en_us2_swap_not_found(inputs)
});
export { swap_not_found as "swap.not_found" }